import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CreaditNoteReasonApi } from '../api/creaditNoteReason.api';
import { switchMap, map } from 'rxjs/operators';
import { creaditNoteReasonData, creaditNoteReason } from '../../../interfaces/masters/creaditNotereason';

@Injectable({
  providedIn: 'root'
})
export class CreaditNoteReasonService  extends creaditNoteReasonData{

  constructor(private api: CreaditNoteReasonApi) {
    super();
  }


  list(url: string): Observable<creaditNoteReason[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<creaditNoteReason>{
      return this.api.getById(url);
  }

  create(url: string, data:creaditNoteReason): Observable<creaditNoteReason[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:creaditNoteReason): Observable<creaditNoteReason> {
    return this.api.update(url,data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}

